import React, { useState, useEffect, useMemo } from "react";
import { Title, Body } from "@vds/typography";
import { useSelector, useDispatch } from "react-redux";
import {
  getTagName,
  getCamerabyId,
  getCameraObjectbyId,
} from "../../../model/reportService";
import {
  setStatistic,
  addNewSubArea,
  setAllTagList,
  putProcessedSiteTagList,
  fetchTags,
  siteTagListUpdated
} from "../../../store/actions";
import { TextLink, TextLinkCaret, Button } from "@vds/buttons";
import { IconButton, TextField } from "@mui/material";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import styled from "styled-components";
import { Input } from "@vds/inputs";
import { Icon } from "@vds/icons";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Checkbox } from "@vds/checkboxes";
import { createNewandGetTagEndPoint, createNewSiteLabelEndPoint } from "../../../configuration";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../global/axiosInterceptor";
import { updateSiteLevelTagWithParkingCount } from "../../../global/utility/Utils";
import { Input as InputField } from "@vds/inputs";
import { RadioButton } from "@vds/radio-buttons";
import {
  AdditionalSubAreaFrame,
  AddText,
} from "../../../global/components/Modals/RoiModals/stylesRoiModal";
import { validateNameField, trimNameField } from "../../EditSites/sitesUtil";
import { NAMING_VALIDATION_ERROR } from "../../../global/constants/errorConstants";
import { isRoiWithDeployedStatus } from "../../../global/utility/statisticsUtil";
const Statistics = ({
  roiLabel,
  cameraId,
  siteId,
  appName,
  setIsStatisticsEdited,
  action,
  EEApp,
  tagids,
  tagSaveStatus,
  setTagSaveStatus,
  netCountWithTagList,
  setNetCountWithTagList
}) => {
  const [selectStatistic, setSelectStatistic] = useState([roiLabel]);
  const [statisticOpen, setStatisticOpen] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [submittedData, setSubmittedData] = useState([]);
  const [selectIndex, setSelectIndex] = useState();
  const roiListWithCvapps = useSelector((state) => state.polygonRoiReducer?.roiListWithCvapps);
  const roiListItem = useMemo(() => roiListWithCvapps?.filter(isRoiWithDeployedStatus), [roiListWithCvapps]);
  const statisticDatas = useSelector(
    (state) => state.polygonRoiReducer.statisticData
  );
  const [actionType, setActionType] = useState("");
  const [statisticDataAll, setStatisticDataAll] = useState([]);
  const [rlabel, setrLabel] = useState();
  const [tags, setTags] = useState([]);
  const [selectFloor, setSelectFloor] = useState("");
  const [siteList, setSiteList] = useState([]);
  const [floorList, setFloorList] = useState([]);
  const [areaList, setAreaList] = useState([]);
  const [subareaList, setSubareaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [selectSubArea, setSelectSubArea] = useState([]);
  const [statisticData, setStatisticData] = useState([roiLabel]);
  const [noZone, setNoZone] = useState("");
  const [subAreaValidationErrors, setSubAreaValidationErrors] = useState({});
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const tagIdList = useSelector((state) => {
    return state.sitesReducer.tagIdList;
  });

  const [locationRadioSelected, setlocationRadioSelected] = useState(
    statisticDatas.length > 0 && statisticDatas[0]?.tags != undefined
      ? statisticDatas[0]?.tags?.filter((t) => t !== siteId)[0]
      : ""
  );

  const [totalParkingCountList, setTotalParkingCountList] = useState([]);
  let arrayitem = [];

  const siteReducerDetail = useSelector((state) => {
      return state.sitesReducer;
    }) ;

  const [sitesTagList, setSitesTagList]  = useState([]);

    useEffect(() => {
      setSitesTagList(siteReducerDetail.siteTagList);
    },[siteReducerDetail?.siteTagList])


  const dispatch = useDispatch();
  let navigate = useNavigate();

  useEffect(() => {
    setlocationRadioSelected(
      statisticDatas.length > 0 && statisticDatas[0]?.tags != undefined
        ? statisticDatas[0]?.tags?.filter((t) => t !== siteId)[0]
        : ""
    );
  }, [statisticDatas]);

  useEffect(() => {
    const cameraList = getCameraObjectbyId(cameraId);
    const statistics = [];
    cameraList &&
      cameraList?.length &&
      cameraList[0]["tagids"]?.length &&
      cameraList[0]["tagids"].map((id) => {
        statistics.push({ tagId: id, name: getTagName(id, tagIdList) });
      });
    setStatisticData(statistics);
    setStatisticOpen(false);
  }, [cameraId]);

  useEffect(() => {
    if (action == "update" && tagids && tagids.length) {
      setTags(tagids);
    }
    if (action == "update" && tagids && tagids.length && !EEApp) {
      const statistics = [];
      const removesiteId = tagids.filter((id) => id !== siteId);
      removesiteId?.length &&
        removesiteId.map((id) => {
          statistics.push(getTagName(id, tagIdList));
        });
      const arr = [
        {
          groupName: roiLabel,
          statisticData: statistics,
          tags: tagids,
          eeAppStatus: EEApp,
        },
      ];
      //setIsStatisticsEdited(action == "update" ? true : false);
      dispatch(setStatistic(arr));
      setStatisticOpen(false);
    }
  }, [tagids]);

  useEffect(() => {
    setStatisticDataAll(statisticDatas);
    resettheState(statisticDatas);
  }, [statisticDatas]);

 useEffect(() => {
  // 1. Guard clause: if no data, do nothing
  const dataList = [...statisticDatas];
  if ((!statisticDatas || statisticDatas.length === 0) || EEApp){
    if((action === "update") && EEApp){
      const roi = roiListItem?.find(f => f.name === roiLabel);
      if(roi?.deployments?.[0]?.config?.["deploy-parameters"]?.zone1){
        dataList.push({
          "groupName":roiLabel,
          "tags":roi.deployments[0].config["deploy-parameters"].zone1,
          "statisticData": undefined,
          "eeAppStatus": "Zone1"
        })
      }
      if(roi?.deployments?.[0]?.config?.["deploy-parameters"]?.zone2){
        dataList.push({
          "groupName":roiLabel,
          "tags":roi.deployments[0].config["deploy-parameters"].zone2,
          "statisticData": undefined,
          "eeAppStatus": "Zone2"
        })
      }
    }else{
      return;
    }

  };

  // 2. Prepare the lookup map for performance (optional but recommended)
  const tagMap = new Map(tagIdList?.map(t => [t.id, t.name]) || []);

  // 3. Create a NEW array with the populated tag names
  // We use .map() to create a new array and {...s} to create new objects
  const enrichedDatas = dataList.map(s => {
    // If statisticData[0] is missing or empty, we fill it
    if (!s.statisticData?.[0] || s.statisticData[0].length === 0) {
      const names = s.tags
        ?.filter(t => t !== siteId)
        .map(tagId => tagMap.get(tagId))
        .filter(Boolean); // Removes undefined if ID wasn't found in tagIdList

      return {
        ...s,
        statisticData: [names, ...(s.statisticData?.slice(1) || [])]
      };
    }
    return s; // Return as is if already has data
  });

  // 4. Update all dependent states at once
  setStatisticDataAll(enrichedDatas);
  resettheState(enrichedDatas);
}, [tagIdList, roiListItem]);

  useEffect(() => {
    if (siteId) {
      handleTags(siteId);
    }
  }, [sitesTagList?.subareas?.length, siteId]);

  const handleTags = (siteId) => {
    const matchingListSites = sitesTagList?.sites?.filter(
      (f) => f?.id === siteId
    );
    const matchingListFloors = sitesTagList?.floors?.filter((f) =>
      f?.tagids?.includes(siteId)
    );
    const matchingListAreas = sitesTagList?.areas?.filter(
      (e) =>
        matchingListFloors?.find((floor) => e.tagids?.includes(floor.id)) !==
        undefined
    );
    const matchingListSubAreas = sitesTagList?.subareas?.filter(
      (e) =>
        matchingListAreas?.find((areas) => e.tagids?.includes(areas.id)) !==
        undefined
    );
    setTags(
      statisticDatas.length > 0
        ? statisticDatas.find((d) => {
            return d.groupName == roiLabel && d.eeAppStatus === EEApp;
          })?.tags
        : []
    );
    console.log(matchingListSites, "matchingListSites >>>");
    setSiteList(matchingListSites);
    setFloorList(matchingListFloors);
    setAreaList(matchingListAreas);
    setSubareaList(matchingListSubAreas);
  };

  const resettheState = (data) => {
    const splitData =
      data && data.length
        ? data.filter((d) => d.groupName == roiLabel && d.eeAppStatus === EEApp)
        : [];
    let appendData = [];
    splitData &&
      splitData.length &&
      splitData[0]?.statisticData.map((data) => {
        appendData.push({ children: data, value: data, selected: true });
      });
    setSubmittedData(appendData);
    //setTags(data[0].tags);
    //setSubmittedData(splitData?.statisticData);
    const filterData =
      splitData && splitData.length ? splitData[0]?.statisticData : [];
    setSelectStatistic(filterData);
    setTags(splitData && splitData.length ? splitData[0]?.tags : []);
  };

  const isSaveButtonDisbale = () => {
    if (
      appName.indexOf("Parking Occupancy") > -1 &&
      selectStatistic &&
      selectStatistic[0] !== "Unused"
    ) {
      if (!tags && !totalParkingCountList) {
        return true;
      } else if (
        tags &&
        totalParkingCountList &&
        tags.length > 0 &&
        totalParkingCountList.length > 0 &&
        totalParkingCountList.length !== tags.length
      ) {
        return true;
      } else if (
        tags &&
        totalParkingCountList &&
        tags.length > 0 &&
        totalParkingCountList.length > 0 &&
        !isEdit &&
        EEApp
      ) {
        return true;
      } else if (
        totalParkingCountList &&
        totalParkingCountList.length > 0 &&
        isEdit
      ) {
        return !(
          selectStatistic.length > 0 && totalParkingCountList.length > 0
        );
      } else if (
        tags &&
        totalParkingCountList &&
        totalParkingCountList.length === 0 &&
        tags.length > 0
      ) {
        return true;
      } else if (
        totalParkingCountList &&
        totalParkingCountList.length == 0 &&
        selectStatistic.length > 0
      ) {
        const locationSelected = tagIdList.find((f) => {
          return selectStatistic.indexOf(f.name) > -1;
        });
        if (
          locationSelected?.parkingcount != undefined &&
          locationSelected?.parkingcount > 0
        ) {
          return false;
        } else {
          return true;
        }
      } else if (selectStatistic.length == 0) {
        return true;
      }
    } else {
      if (!isEdit) {
        return true;
      }
      return !(selectStatistic.length > 0);
    }
  };

  const handleSelectedTags = (e, selectedid, name) => {
    const checked = e.target.checked;
    selectedid === "-1" && checked ? setNoZone("Unused") : setNoZone("");
    // console.log(selectedid, tags, checked, selectedid === "-1" && checked ? "selectedid >>>": "selectID>>>");
    if (checked) {
      if (tags && tags.length && !tags?.includes(selectedid)) {
        //selectSubArea.push(subareaid);
        if (selectedid === "-1") {
          setTags([selectedid]);
          setSelectStatistic(["Unused"]);
        } else {
          setTags([...tags, selectedid]);
          selectStatistic.push(name);
          setSelectStatistic(selectStatistic);
        }
        // console.log(selectStatistic, tags,[...tags, selectedid], "selectStatistic >>>1")
        //setSelectSubArea(selectSubArea);
      } else {
        if (selectedid === "-1") {
          setSelectStatistic(["Unused"]);
        } else {
          selectStatistic.push(name);
          setSelectStatistic(selectStatistic);
        }
        setTags([selectedid]);
      }
    } else {
      const removetagName = selectStatistic.filter((item) => item !== name);
      const removetagId = tags.filter((id) => id !== selectedid);
      if (appName.indexOf("Parking Occupancy") > -1) {
        const totalParking = totalParkingCountList.filter(
          (item) => item.id !== selectedid
        );
        setTotalParkingCountList(totalParking);
      }

      //const removeSubarea = selectSubArea.filter((id)=>id !== selectedid);
      //setSelectSubArea(removeSubarea);
      setTags(removetagId);
      // console.log(selectStatistic, "selectStatistic >>>2");
      setSelectStatistic(removetagName);
    }
  };
  useEffect(() => {
    invokeTaggedParkingCountUpdate(tagSaveStatus);
  }, [tagSaveStatus]);

  
const invokeTaggedParkingCountUpdate = async (tagSaveStatus) =>{
  if (
      appName.indexOf("Parking Occupancy") > -1 &&
      netCountWithTagList.length > 0 &&
      tagSaveStatus
    ) {
       const resultedresult = Promise.all(
      netCountWithTagList.map(async (element) => {
        const payload = {
          accountname: activeSession.accountId,
          resourceidentifier: {
            id: element?.id,
          },
          tag: {
            parkingCount: element.parkingcount,
          },
        };
        const result = await updateSiteLevelTagWithParkingCount(payload);
        if (result && result.name !== undefined) {
          // setOriginalSiteName(result.name);

          // Update tagIdList with proper immutable update
          const updatedTagIdList = (tagIdList || []).map((m) => {
            if (m.id == result?.id) {
              return { ...m, ...result };
            }
            return m;
          });
          dispatch(setAllTagList(updatedTagIdList));
        return await result;

        
          
        } else {
          console.error("Failed to update site name");
        }
      }));
      let resultList = await resultedresult;
      updateSiteTagListReducer(resultList);
      setTagSaveStatus(false);
    }
}

  //Update Reducer of sitetaglist  after tag update with praking count 
  //For real time rendering post update on statistics popup .
  const updateSiteTagListReducer = (resultList) =>{
    let suabarealist = sitesTagList?.subareas;
    let arealist = sitesTagList?.areas;
    let floorlist = sitesTagList?.floors;
    let sitelist = sitesTagList?.sites;
resultList.forEach(result => {
    if(result.kind.indexOf(".subArea") != -1){
            
            suabarealist = suabarealist.map(m => {
              if(m.id == result.id){
                m = result;
              }
              return m;
            })
            
          }
          else if(result.kind.indexOf(".area") != -1){
            
            arealist = arealist.map(m => {
              if(m.id == result.id){
                m = result;
              }
              return m;
            })
            //dispatch(siteTagListUpdated({...sitesTagList, areas:arealist}));
          }
          else if(result.kind.indexOf(".floor") != -1){
            
            floorlist = floorlist.map(m => {
              if(m.id == result.id){
                m = result;
              }
              return m;
            })
            
          }
          else if(result.kind.indexOf(".site") != -1){
            
            sitelist = sitelist.map(m => {
              if(m.id == result.id){
                m = result;
              }
              return m;
            })
          }
          });
          dispatch(siteTagListUpdated({...sitesTagList, 
            sites:sitelist,
            floors:floorlist,
            areas:arealist, 
            subareas:suabarealist}));
  }
  const handleSubmitStatistic = () => {
    let splitData =
      statisticDataAll && statisticDataAll.length
        ? statisticDataAll.filter((d) => d.groupName == roiLabel)
        : [];
    if (EEApp && actionType === "edit") {
      splitData = splitData.filter((d) => d.eeAppStatus !== EEApp);
    }
    const mergeData = EEApp
      ? [
          ...splitData,
          ...[
            {
              groupName: roiLabel,
              statisticData: selectStatistic,
              tags: tags,
              eeAppStatus: EEApp,
            },
          ],
        ]
      : [
          {
            groupName: roiLabel,
            statisticData: selectStatistic,
            tags: tags,
            eeAppStatus: EEApp,
          },
        ];
        if(netCountWithTagList.length == 0){
          setNetCountWithTagList(totalParkingCountList);
        }else if(netCountWithTagList.length > 0 && totalParkingCountList.length > 0){
          const hasMatchingId = netCountWithTagList.some(item => item.id === totalParkingCountList[0].id);
          if (!hasMatchingId) {
            const fullParkingCountList = [...netCountWithTagList, ...totalParkingCountList];
            setNetCountWithTagList(fullParkingCountList);
          }
        }
    //const mergeData = splitData && splitData.length ? [...splitData, ...[{groupName: rlabel, statisticData: selectStatistic, tags: tags}]]: [{groupName: rlabel, statisticData: selectStatistic, tags: tags}];
    setIsStatisticsEdited(action == "update" ? true : false);

    dispatch(setStatistic(mergeData));
    setStatisticOpen(false);
  };

  // useEffect(() => {
  //   console.log(totalParkingCountList);
  // }, [totalParkingCountList]);

  const modalOpen = (type) => {
    if (action === "update") {
      let splitData =
        statisticDataAll && statisticDataAll.length
          ? statisticDataAll.filter(
              (d) => d.groupName == roiLabel && d.eeAppStatus === EEApp
            )
          : [];
      setTags(
        EEApp
          ? splitData[0]?.tags
          : splitData[0]?.tags?.filter((t) => t !== siteId)
      );
      setNoZone(splitData[0]?.tags[0] === "-1" ? "Unused" : "");
      if (
        appName.indexOf("Parking Occupancy") > -1 &&
        splitData[0]?.tags[0] !== "-1"
      ) {
        setTimeout(() => {
          updateParkingCount(EEApp ? splitData[0]?.tags : tags);
        }, 100);
      }
    }
    //handleTags(siteId);
    setActionType(type);
    setStatisticOpen(false);
    setTimeout(() => {
      setStatisticOpen(true);
    }, 100);
  };

  const handleDeleteSubArea = (subareas, selectedareaid) => {
    const removematchingSubArea = subareaList?.filter(
      (subareas) =>
        (subareas.id !== null && subareas.tagids?.includes(selectedareaid)) ||
        !subareas.tagids?.includes(selectedareaid)
    );
    setSubareaList(removematchingSubArea);
  };

  const createNewSubAreaTag = async (payload) => {
    try {
      const response = await axiosInstance.post(
        createNewSiteLabelEndPoint(),
        payload
      );

      // if (!response.ok) {
      //   throw new Error("Failed to create new sub area tag");
      // }

      const data = response.data;
      return data;
    } catch (error) {
      console.error("Error creating new sub area tag:", error);
      throw error;
    }
  };

    const handleNewSubArea = async (subarea, areaid) => {
        // Validate before creating
        if (!subarea.name || !validateNameField(subarea.name)) {
          return;
        }
        const payload = {
            accountname: activeSession.accountId,
            tags: [
                {
                    kind: "ts.tag.subArea",
                    name: trimNameField(subarea.name),
                    tagids: [areaid]
                }
            ]
        };
        try {
            const response = await createNewSubAreaTag(payload);
            if (response && response.length > 0) {
                const newSubArea = response[0];
                const newSubareaList = subareaList?.filter(
                    (subareas) =>
                        (subareas.id !== null && subareas.tagids?.includes(areaid)) ||
                        !subareas.tagids?.includes(areaid)
                );
                const tagData = [...(tagIdList || []), newSubArea];
                dispatch(setAllTagList(tagData));
                // Dispatching addNewSubArea to update Redux sitesTagList.subareas
                dispatch(addNewSubArea(newSubArea));
                setSubareaList([...newSubareaList, newSubArea]);
                // Clear validation error after successful creation
                setSubAreaValidationErrors(prev => {
                  const { [`${areaid}_new_subarea`]: removed, ...rest } = prev;
                  return rest;
                });
            } else {
                console.error("Failed to create new sub area tag");
            }
        } catch (error) {
            console.error("Error creating new sub area tag:", error);
        }
    };

  const handleSubAreaName = (e, subareas, areaId) => {
    const rawValue = e.target.value;
    subareas.name = rawValue;
    const errorKey = `${areaId}_new_subarea`;
    if (rawValue && !validateNameField(rawValue)) {
      setSubAreaValidationErrors(prev => ({ ...prev, [errorKey]: NAMING_VALIDATION_ERROR }));
    } else {
      setSubAreaValidationErrors(prev => {
        const { [errorKey]: removed, ...rest } = prev;
        return rest;
      });
    }
  };

  const handleParkingCount = (id, parkingcount) => {
    if (!EEApp) {
      return;
    }
    const parkings = totalParkingCountList.filter((item) => item.id === id);
    if (parkings.length === 0 && parkingcount && EEApp) {
      totalParkingCountList.push({
        id: id,
        parkingcount: parkingcount,
      });
      setTotalParkingCountList([...totalParkingCountList]);
    }
  };
  const checkboxSelection = (id, parkingcount) => {
    if (tags?.includes(id)) {
      return true;
    } else {
      return false;
    }
  };
  const redioSelection = (id, parkingcount) => {
    if (locationRadioSelected === id) {
      handleParkingCount(id, parkingcount);
      return true;
    } else {
      return false;
    }
  };
  const updateParkingCount = (tagsids) => {
    tagsids?.map((tagid) => {
      const siteFilter = siteList.filter((f) => f.id === tagid);
      const floorFilter = floorList.filter((f) => f.id === tagid);
      const areaFilter = areaList.filter((f) => f.id === tagid);
      const subAreaFilter = subareaList.filter((f) => f.id === tagid);
      siteFilter?.map((m) => {
        handleParkingCount(m?.id, m?.parkingcount);
      });
      floorFilter?.map((m) => {
        handleParkingCount(m?.id, m?.parkingcount);
      });
      areaFilter?.map((m) => {
        handleParkingCount(m?.id, m?.parkingcount);
      });
      subAreaFilter?.map((m) => {
        handleParkingCount(m?.id, m?.parkingcount);
      });
    });
  };
  return (
    <>
      <div
        className="vision-roi-last"
        style={{ minHeight: "150px", paddingBottom: "10px" }}
      >
        {/* {!EEApp &&  */}
        <div
          className="vision-roi-col"
          style={{ marginLeft: "10px", paddingTop: "20px" }}
        >
          {!EEApp && (
            <Title size="small" primitive="h2" viewport="desktop">
              Statistics
            </Title>
          )}
          {submittedData?.length !== 0 && (
            <div style={{ paddingLeft: EEApp ? "75%" : "0px" }}>
              <TextLink
                size="small"
                data-testid="statistics_editTextLink"
                onClick={(e) => {
                  modalOpen("edit");
                  //setTotalParkingCountList([]);
                }}
                type="standAlone"
              >
                Edit
              </TextLink>
            </div>
          )}
        </div>
        {/* } */}
        <Modal
          minHeight="400px"
          opened={statisticOpen}
          disableOutsideClick={true}
          ariaLabel="Testing Modal"
          hideCloseButton={true}
        >
          <Title size="large" bold primitive="h2" viewport="desktop">
            Statistics
          </Title>
          <ModalBody>
            <div style={{ padding: "20px 0 20px 0" }}>
              <Body size="large" viewport="desktop" primitive="h2">
                Choose the location(s) that this region of interest (ROI) will
                contribute to the {appName} of.
              </Body>
              <Body size="small" viewport="desktop" primitive="p" color="#FF8027">
                <strong>Information:</strong> This location (Floor/Area/Subarea) is shared within the portal. Changes made here will reflect across all apps mapped to this hierarchy.
              </Body>
            </div>

            {EEApp && (
              <>
                <div>
                  <label>
                    <Checkbox
                      name="default"
                      width="auto"
                      label={"  "}
                      selected={tags?.includes("-1") ? true : false}
                      error={false}
                      data-testid="statistics_dontCountCheckbox"
                      onChange={(e) => {
                        handleSelectedTags(e, "-1", "Unused");
                        setIsEdit(true);
                      }}
                    />
                  </label>
                  <Body size="large" viewport="desktop" primitive="span">
                    Don’t count statistics for this zone
                  </Body>
                  {/* <div style={{paddingLeft: "35px", marginBottom: "15px"}}>
                  <Body size="small" viewport="desktop" primitive="span">
                  Select if this zone should not contribute to any count. Can only be selected once per region of interest.    
                  </Body>
                  </div> */}
                </div>

                <div
                  style={{
                    margin: "15px 0 0px 8px",
                    // display: "flex",
                    width: "400px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <label>
                      <Checkbox
                        name="default"
                        width="auto"
                        label={"  "}
                        selected={checkboxSelection(
                          siteList?.[0]?.id,
                          siteList?.[0]?.parkingcount
                        )}
                        error={false}
                        disabled={tags?.includes("-1") ? true : false}
                        data-testid="statistics_siteNameCheckbox"
                        onChange={(e) => {
                          handleSelectedTags(e, siteId, siteList[0]?.name);
                          setIsEdit(true);
                          if (siteList?.[0]?.parkingcount && e.target.checked) {
                            handleParkingCount(
                              siteList?.[0]?.id,
                              siteList?.[0]?.parkingcount
                            );
                          }
                        }}
                      />
                    </label>

                    <Input
                      type="text"
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.3rem",
                          }}
                        >
                          <div>Site name</div>
                        </div>
                      }
                      value={siteList?.[0]?.name}
                    />
                  </div>

                  {appName.indexOf("Parking Occupancy") > -1 &&
                    tags?.includes(siteId) && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          margin: "10px 0 10px 20px",
                        }}
                      >
                        <InputField
                          type="number"
                          label={"Parking Capacity"}
                          width={"50%"}
                          paddingLeft={"32px"}
                          data-testid="statistics_parkingCapacityInput"
                          onChange={(e) => {
                            console.log(e.target.value);
                            var locationlist = totalParkingCountList;
                            const locationlistIds = locationlist?.map((l) => {
                              return l?.id;
                            });
                            if (e.target.value != "") {
                              if (
                                locationlistIds.indexOf(e.target.ariaLabel) ==
                                -1
                              ) {
                                locationlist.push({
                                  id: e.target.ariaLabel,
                                  parkingcount: e.target.value,
                                });
                              } else {
                                const index = locationlistIds.indexOf(
                                  e.target.ariaLabel
                                );
                                locationlist = locationlist.map((m) => {
                                  if (m?.id == e.target.ariaLabel) {
                                    m.parkingcount = e.target.value;
                                  }
                                  return m;
                                });
                              }
                            } else {
                              const index = locationlistIds.indexOf(
                                e.target.ariaLabel
                              );
                              locationlist.splice(index, 1);
                            }
                            setIsEdit(true);
                            setTotalParkingCountList([...locationlist]);
                          }}
                          aria-label={siteId}
                          helperText={
                            "Enter the number of parking spaces visible in this region of interest."
                          }
                          helperTextPlacement="bottom"
                          defaultValue={parseInt(
                            totalParkingCountList.length > 0
                              ? totalParkingCountList.find(
                                  (f) => f.id == siteId
                                )?.parkingcount
                              : siteList[0]?.parkingcount
                          )}
                        />
                      </div>
                    )}
                </div>
              </>
            )}
            {floorList && floorList.length && (
              <div
                style={{
                  padding: "20px 0 20px 0",
                  overflow: "auto",
                  height: "400px",
                }}
              >
                {floorList?.map((floor) => (
                  <>
                    <div
                      style={{
                        margin: "0px 0 10px 8px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{
                          margin: "0px 0 10px 8px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                          }}
                        >
                          {appName.indexOf("Entry/Exit") > -1 ||
                          appName.indexOf("EE") > -1 ? (
                            <label>
                              <Checkbox
                                name="default"
                                width="auto"
                                label={"  "}
                                selected={checkboxSelection(
                                  floor?.id,
                                  floor?.parkingcount
                                )}
                                error={false}
                                disabled={tags?.includes("-1") ? true : false}
                                data-testid="statistics_floorNameCheckbox"
                                onChange={(e) => {
                                  setIsEdit(true);
                                  handleSelectedTags(e, floor?.id, floor?.name);
                                  if (floor?.parkingcount && e.target.checked) {
                                    handleParkingCount(
                                      floor?.id,
                                      floor?.parkingcount
                                    );
                                  }
                                }}
                              />
                            </label>
                          ) : (
                            ""
                          )}
                          <Input
                            type="text"
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.3rem",
                                }}
                              >
                                <div>Floor name</div>
                              </div>
                            }
                            value={floor?.name}
                          />
                        </div>
                        {appName.indexOf("Parking Occupancy") > -1 &&
                          tags?.includes(floor?.id) && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                margin: "10px 0 10px 20px",
                              }}
                            >
                              <InputField
                                type="number"
                                label={"Parking Capacity"}
                                width={"50%"}
                                paddingLeft={"32px"}
                                data-testid="statistics_parkingCapacityInput"
                                onChange={(e) => {
                                  var locationlist = totalParkingCountList;
                                  const locationlistIds = locationlist?.map(
                                    (l) => {
                                      return l?.id;
                                    }
                                  );
                                  if (e.target.value != "") {
                                    if (
                                      locationlistIds.indexOf(
                                        e.target.ariaLabel
                                      ) == -1
                                    ) {
                                      locationlist.push({
                                        id: e.target.ariaLabel,
                                        parkingcount: e.target.value,
                                      });
                                    } else {
                                      const index = locationlistIds.indexOf(
                                        e.target.ariaLabel
                                      );
                                      locationlist = locationlist.map((m) => {
                                        if (m?.id == e.target.ariaLabel) {
                                          m.parkingcount = e.target.value;
                                        }
                                        return m;
                                      });
                                    }
                                  } else {
                                    const index = locationlistIds.indexOf(
                                      e.target.ariaLabel
                                    );
                                    locationlist.splice(index, 1);
                                  }
                                  setIsEdit(true);
                                  setTotalParkingCountList([...locationlist]);
                                }}
                                aria-label={floor?.id}
                                helperText={
                                  "Enter the number of parking spaces visible in this region of interest."
                                }
                                helperTextPlacement="bottom"
                                defaultValue={parseInt(
                                  totalParkingCountList.length > 0
                                    ? totalParkingCountList.find(
                                        (f) => f.id == floor?.id
                                      )?.parkingcount
                                    : floor?.parkingcount
                                )}
                              />
                            </div>
                          )}
                      </div>
                      <div
                        style={{
                          borderLeft: "1px solid rgba(0,0,0,0.3)",
                          padding: "10px",
                        }}
                      >
                        {areaList &&
                          areaList.length &&
                          areaList
                            ?.filter((area) => {
                              return area?.tagids?.includes(floor.id);
                            })
                            .map((area) => (
                              <div
                                style={{
                                  margin: "0px 0 10px 8px",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <div
                                  style={{
                                    margin: "0px 0 10px 8px",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                    }}
                                  >
                                    <label>
                                      {(appName.indexOf("Entry/Exit") > -1 ||
                                        appName.indexOf("EE") > -1) && (
                                        <Checkbox
                                          name="default"
                                          width="auto"
                                          label={"  "}
                                          selected={checkboxSelection(
                                            area?.id,
                                            area?.parkingcount
                                          )}
                                          disabled={
                                            tags?.includes("-1") ? true : false
                                          }
                                          error={false}
                                          data-testid="statistics_areaNameCheckbox"
                                          onChange={(e) => {
                                            handleSelectedTags(
                                              e,
                                              area?.id,
                                              area?.name
                                            );
                                            setIsEdit(true);
                                            if (
                                              area?.parkingcount &&
                                              e.target.checked
                                            ) {
                                              handleParkingCount(
                                                area?.id,
                                                area?.parkingcount
                                              );
                                            }
                                          }}
                                        />
                                      )}
                                      {appName.indexOf("Entry/Exit") == -1 &&
                                        appName.indexOf("EE") == -1 && (
                                          <RadioButton
                                            name="group"
                                            label={" "}
                                            selected={redioSelection(
                                              area?.id,
                                              area?.parkingcount
                                            )}
                                            //children={option.children}
                                            data-testid="statistics_areaCheckbox"
                                            onChange={(e) => {
                                              setlocationRadioSelected(
                                                e.target.value
                                              );
                                              setTags([e.target.value]);
                                              setSelectStatistic([
                                                areaList.find((a) => {
                                                  return a.id == e.target.value;
                                                }).name,
                                              ]);
                                              setIsEdit(true);
                                              if (area?.parkingcount) {
                                                setTotalParkingCountList([
                                                  {
                                                    id: area?.id,
                                                    parkingcount:
                                                      area?.parkingcount,
                                                  },
                                                ]);
                                              } else {
                                                setTotalParkingCountList([]);
                                              }
                                            }}
                                            value={area?.id}
                                            disabled={noZone ? true : false}
                                          />
                                        )}
                                    </label>
                                    <Input
                                      type="text"
                                      label={
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "0.3rem",
                                          }}
                                        >
                                          <div>Area name</div>
                                          <InfoOutlinedIcon
                                            fontSize="small"
                                            sx={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      }
                                      value={area?.name}
                                    />
                                  </div>
                                  {appName.indexOf("Parking Occupancy") > -1 &&
                                    tags?.includes(area?.id) && (
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          margin: "10px 0 10px 20px",
                                        }}
                                      >
                                        <InputField
                                          type="number"
                                          label={"Parking Capacity"}
                                          width={"50%"}
                                          paddingLeft={"32px"}
                                          data-testid="statistics_areaNameCheckbox"
                                          onChange={(e) => {
                                            var locationlist =
                                              totalParkingCountList;
                                            const locationlistIds =
                                              locationlist?.map((l) => {
                                                return l?.id;
                                              });
                                            if (e.target.value != "") {
                                              if (
                                                locationlistIds.indexOf(
                                                  e.target.ariaLabel
                                                ) == -1
                                              ) {
                                                locationlist.push({
                                                  id: e.target.ariaLabel,
                                                  parkingcount: e.target.value,
                                                });
                                              } else {
                                                const index =
                                                  locationlistIds.indexOf(
                                                    e.target.ariaLabel
                                                  );
                                                locationlist = locationlist.map(
                                                  (m) => {
                                                    if (
                                                      m?.id ==
                                                      e.target.ariaLabel
                                                    ) {
                                                      m.parkingcount =
                                                        e.target.value;
                                                    }
                                                    return m;
                                                  }
                                                );
                                              }
                                            } else {
                                              const index =
                                                locationlistIds.indexOf(
                                                  e.target.ariaLabel
                                                );

                                              locationlist.splice(index, 1);
                                            }
                                            setIsEdit(true);
                                            setTotalParkingCountList([
                                              ...locationlist,
                                            ]);
                                          }}
                                          aria-label={area?.id}
                                          helperText={
                                            "Enter the number of parking spaces visible in this region of interest."
                                          }
                                          helperTextPlacement="bottom"
                                          defaultValue={parseInt(
                                            totalParkingCountList.length > 0
                                              ? totalParkingCountList.find(
                                                  (f) => f.id == area?.id
                                                )?.parkingcount
                                              : area?.parkingcount
                                          )}
                                        />
                                      </div>
                                    )}
                                </div>
                                <div
                                  style={{
                                    borderLeft: "1px solid rgba(0,0,0,0.3)",
                                    marginLeft: "10px",
                                  }}
                                >
                                  {subareaList &&
                                  subareaList.length !== 0 &&
                                  subareaList?.find(
                                    (subarea) =>
                                      subarea.tagids?.includes(area.id) &&
                                      subarea.id === null
                                  ) !== undefined ? (
                                    ""
                                  ) : (
                                    <div
                                      style={{
                                        margin: "20px 0 10px 26px",
                                        display: "flex",
                                      }}
                                    >
                                      <AdditionalSubAreaFrame
                                        data-testid="statistics_addSubAreaPlusIcon"
                                        onClick={() =>
                                          setSubareaList([
                                            {
                                              id: null,
                                              kind: "ts.tag.subArea",
                                              name: "",
                                              tagids: [area.id],
                                            },
                                            ...subareaList,
                                          ])
                                        }
                                      >
                                        <Icon
                                          name="plus"
                                          color="#000000"
                                          size="large"
                                          style={{ cursor: "pointer" }}
                                        />
                                        <AddText>Add sub-area</AddText>
                                      </AdditionalSubAreaFrame>{" "}
                                    </div>
                                  )}
                                  {subareaList
                                    ?.filter((subarea) => {
                                      return subarea?.tagids?.includes(area.id);
                                    })
                                    .map((subareas) => {
                                      return (
                                        <div
                                          style={{
                                            margin: "0px 0 10px 8px",
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              marginLeft: "20px",
                                            }}
                                          >
                                            {subareas?.id !== null ? (
                                              <label>
                                                {(appName.indexOf(
                                                  "Entry/Exit"
                                                ) > -1 ||
                                                  appName.indexOf("EE") >
                                                    -1) && (
                                                  <Checkbox
                                                    name="default"
                                                    width="auto"
                                                    label={"  "}
                                                    selected={checkboxSelection(
                                                      subareas?.id,
                                                      subareas?.parkingcount
                                                    )}
                                                    disabled={
                                                      subareas?.id === null ||
                                                      (tags?.includes("-1")
                                                        ? true
                                                        : false)
                                                    }
                                                    error={false}
                                                    data-testid="statistics_subAreaCheckbox"
                                                    onChange={(e) => {
                                                      setIsEdit(true);
                                                      handleSelectedTags(
                                                        e,
                                                        subareas?.id,
                                                        subareas?.name
                                                      );
                                                      if (
                                                        subareas?.parkingcount &&
                                                        e.target.checked
                                                      ) {
                                                        handleParkingCount(
                                                          subareas?.id,
                                                          subareas?.parkingcount
                                                        );
                                                      }
                                                    }}
                                                  />
                                                )}
                                                {appName.indexOf(
                                                  "Entry/Exit"
                                                ) == -1 &&
                                                  appName.indexOf("EE") ==
                                                    -1 && (
                                                    <RadioButton
                                                      name="group"
                                                      label={" "}
                                                      selected={redioSelection(
                                                        subareas?.id,
                                                        subareas?.parkingcount
                                                      )}
                                                      //children={option.children}
                                                      data-testid="statistics_subAreaRadioButton"
                                                      onChange={(e) => {
                                                        setlocationRadioSelected(
                                                          e.target.value
                                                        );
                                                        setTags([
                                                          e.target.value,
                                                        ]);
                                                        setIsEdit(true);
                                                        if (
                                                          subareas?.parkingcount
                                                        ) {
                                                          setTotalParkingCountList(
                                                            [
                                                              {
                                                                id: subareas?.id,
                                                                parkingcount:
                                                                  subareas?.parkingcount,
                                                              },
                                                            ]
                                                          );
                                                        } else {
                                                          setTotalParkingCountList(
                                                            []
                                                          );
                                                        }
                                                        setSelectStatistic([
                                                          subareaList.find(
                                                            (a) => {
                                                              return (
                                                                a.id ==
                                                                e.target.value
                                                              );
                                                            }
                                                          ).name,
                                                        ]);
                                                      }}
                                                      value={subareas?.id}
                                                      disabled={
                                                        noZone ? true : false
                                                      }
                                                    />
                                                  )}
                                              </label>
                                            ) : (
                                              ""
                                            )}
                                            {subareas?.id !== null ? (
                                              <Input
                                                type="text"
                                                label="Sub-area name"
                                                value={subareas?.name}
                                              />
                                            ) : (
                                              ""
                                            )}

                                            {subareas?.id === null ? (<>
                                               <label style={{width: "30px"}}></label>
                                              <Input
                                                type="text"
                                                label="New Sub-area"
                                                data-testid="statistics_newSubAreaInput"
                                                onChange={(e) => handleSubAreaName(e, subareas, area.id)}
                                                defaultValue={
                                                  subareas?.name === ""
                                                    ? ""
                                                    : subareas?.name
                                                }
                                                error={!!subAreaValidationErrors[`${area.id}_new_subarea`]}
                                                errorText={subAreaValidationErrors[`${area.id}_new_subarea`] || " "}
                                              /></>
                                            ) : (
                                              ""
                                            )}

                                            {subareas?.id === null ? (
                                              <IconButton
                                                data-testid="statistics_addSubAreaPlusIcon"
                                                onClick={() => {
                                                  handleNewSubArea(
                                                    subareas,
                                                    area.id
                                                  );
                                                }}
                                                style={{
                                                  cursor: subAreaValidationErrors[`${area.id}_new_subarea`] ? "not-allowed" : "pointer",
                                                  top: "8px",
                                                }}
                                                disabled={!!subAreaValidationErrors[`${area.id}_new_subarea`]}
                                              >
                                                <Icon
                                                  name="checkmark"
                                                  color={subAreaValidationErrors[`${area.id}_new_subarea`] ? "#A7A7A7" : "#000000"}
                                                  size="large"
                                                />
                                              </IconButton>
                                            ) : (
                                              ""
                                            )}
                                            {subareas?.id === null ? (
                                              <IconButton
                                                data-testid="statistics_deleteSubAreaPlusIcon"
                                                onClick={() => {
                                                  handleDeleteSubArea(
                                                    subareas,
                                                    area.id
                                                  );
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  top: "8px",
                                                }}
                                              >
                                                <Icon
                                                  name="trash"
                                                  color="#000000"
                                                  size="large"
                                                />
                                              </IconButton>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                          {appName.indexOf(
                                            "Parking Occupancy"
                                          ) > -1 &&
                                            tags?.includes(subareas?.id) && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                  margin: "10px 0 10px 20px",
                                                }}
                                              >
                                                <InputField
                                                  type="number"
                                                  label={"Parking Capacity"}
                                                  width={"50%"}
                                                  paddingLeft={"32px"}
                                                  data-testid="statistics_parkingCapacityInput"
                                                  onChange={(e) => {
                                                    console.log(e.target.value);
                                                    var locationlist =
                                                      totalParkingCountList;
                                                    const locationlistIds =
                                                      locationlist?.map((l) => {
                                                        return l?.id;
                                                      });
                                                    if (e.target.value != "") {
                                                      if (
                                                        locationlistIds.indexOf(
                                                          e.target.ariaLabel
                                                        ) == -1
                                                      ) {
                                                        locationlist.push({
                                                          id: e.target
                                                            .ariaLabel,
                                                          parkingcount:
                                                            e.target.value,
                                                        });
                                                      } else {
                                                        const index =
                                                          locationlistIds.indexOf(
                                                            e.target.ariaLabel
                                                          );
                                                        locationlist =
                                                          locationlist.map(
                                                            (m) => {
                                                              if (
                                                                m?.id ==
                                                                e.target
                                                                  .ariaLabel
                                                              ) {
                                                                m.parkingcount =
                                                                  e.target.value;
                                                              }
                                                              return m;
                                                            }
                                                          );
                                                      }
                                                    } else {
                                                      const index =
                                                        locationlistIds.indexOf(
                                                          e.target.ariaLabel
                                                        );
                                                      locationlist.splice(
                                                        index,
                                                        1
                                                      );
                                                    }
                                                    setIsEdit(true);
                                                    setTotalParkingCountList([
                                                      ...locationlist,
                                                    ]);
                                                  }}
                                                  aria-label={subareas?.id}
                                                  helperText={
                                                    "Enter the number of parking spaces visible in this region of interest."
                                                  }
                                                  helperTextPlacement="bottom"
                                                  defaultValue={parseInt(
                                                    totalParkingCountList.length >
                                                      0
                                                      ? totalParkingCountList.find(
                                                          (f) =>
                                                            f.id == subareas?.id
                                                        )?.parkingcount
                                                      : subareas?.parkingcount
                                                  )}
                                                />
                                              </div>
                                            )}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            ))}
                      </div>
                    </div>
                  </>
                ))}
              </div>
            )}
          </ModalBody>
          <div
            style={{
              width: "100%",
              position: "sticky",
              marginTop: "15px",
              display: "flex",
              justifyContent: "space-between",
            }}
          ></div>
          <ModalFooter>
            {" "}
            <div
              style={{
                width: "29rem",
                position: "fixed",
                top: "80%",
                // position: "absolute",
                // top: "95%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                // display: "flex",
                // justifyContent: "space-between",
                // marginTop:"-80px",
              }}
            >
              <Button
                size="large"
                use="primary"
                width="100%"
                data-testid="statistics_saveButton"
                onClick={() => {
                  handleSubmitStatistic();
                }}
                disabled={isSaveButtonDisbale()}
              >
                Save
              </Button>
            </div>
          </ModalFooter>
        </Modal>
        <div style={{ paddingTop: "10px", textAlign: "center" }}>
          {!EEApp && submittedData?.length === 0 && (
            <Button
              size="large"
              disabled={false}
              use="primary"
              data-testid="statistics_createStatisticButton"
              onClick={(e) => {
                modalOpen("create");
              }}
            >
              Create Statistic
            </Button>
          )}
          {EEApp && submittedData?.length === 0 && (
            <TextLink
              size="large"
              data-testid="statistics_selectLocationsTextLink"
              onClick={() => {
                modalOpen("create");
              }}
            >
              Select location(s)
            </TextLink>
          )}

          {submittedData?.length !== 0 &&
            selectStatistic.map((item) => {
              return (
                <div
                  style={{
                    display: "flex",
                    padding: "10px",
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                  }}
                >
                  <input
                    type="checkbox"
                    className="checkbox"
                    style={{
                      width: "1rem",
                      height: "1rem",
                      marginRight: "8px",
                      marginTop: "2px",
                    }}
                    checked={true}
                  />
                  {/* <Title size="small" primitive="h2" viewport="desktop">
                    {item}
                  </Title> */}
                  <span
                    style={{
                      fontSize: "14px",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                      lineHeight: "1.4",
                      maxWidth: "calc(100% - 1.5rem)",
                    }}
                  >
                    {item}
                  </span>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Statistics;
